export default {
  SubmitRequest: 'submitRequest',
};
